import { GaussianBlurBackgroundProcessor, isSupported } from '@twilio/video-processors';
import { LocalVideoTrack } from 'twilio-video';
import { useCallback, useState } from 'react';

export const useVideoFilter = (localTracks) => {
  const localVideoTrack = localTracks.find(track => track.name.includes('camera')) as LocalVideoTrack;
  const [ isEnabled, setEnabled ] = useState(false);

  const toggleVideoFilter = useCallback(async (reset?: boolean) => {
    if (reset) {
      setEnabled(false);
    } else if (localVideoTrack && isSupported) {
      if (localVideoTrack.processor) {
        localVideoTrack.removeProcessor(localVideoTrack.processor);
        setEnabled(false);
      } else {
        const gaussianBlurProcessor = new GaussianBlurBackgroundProcessor({
          assetsPath: '/assets/',
          maskBlurRadius: 10,
          blurFilterRadius: 20,
        });

        await gaussianBlurProcessor.loadModel();
        localVideoTrack.addProcessor(gaussianBlurProcessor);
        setEnabled(true);
      }
    }
  }, [ localVideoTrack ]);

  return {
    toggleVideoFilter,
    isSupported,
    isEnabled
  };
};
